export default {"src":"/_next/static/media/matlab.77f7303a.svg","height":234,"width":257,"blurWidth":0,"blurHeight":0};